/**
 * @generated SignedSource<<0a5fa1bfe7734ad90a5fdf58a6f987dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteAssetInput = {
  assetId: string;
  clientMutationId?: string | null;
};
export type ActiveElementContent_DeleteAsset_Mutation$variables = {
  input: DeleteAssetInput;
};
export type ActiveElementContent_DeleteAsset_Mutation$data = {
  readonly deleteAsset: {
    readonly ok: boolean | null;
  } | null;
};
export type ActiveElementContent_DeleteAsset_Mutation = {
  response: ActiveElementContent_DeleteAsset_Mutation$data;
  variables: ActiveElementContent_DeleteAsset_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAssetPayload",
    "kind": "LinkedField",
    "name": "deleteAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveElementContent_DeleteAsset_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveElementContent_DeleteAsset_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "52a2a22a7e96aa4ba8373195e7713426",
    "id": null,
    "metadata": {},
    "name": "ActiveElementContent_DeleteAsset_Mutation",
    "operationKind": "mutation",
    "text": "mutation ActiveElementContent_DeleteAsset_Mutation(\n  $input: DeleteAssetInput!\n) {\n  deleteAsset(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1d05e4fd3ed4a0969aa77433293166a";

export default node;
